import { Divider, Form, InputNumber, InputNumberProps } from 'antd';
import { observer } from 'mobx-react-lite';
import moment from 'moment';

const formatPosInt = (num: number) => Math.trunc(Math.abs(num));

type RelativeNumberDateProps = {
  value?: number;
  onChange?: (value: number | null) => void;
  relativeDateFieldName?: string[] | string;
  withDuration?: boolean;
  status?: InputNumberProps['status'];
};

export const FormInputRelativeDate = observer(
  ({
    value,
    onChange,
    relativeDateFieldName,
    withDuration,
    status,
  }: RelativeNumberDateProps) => {
    const form = Form.useFormInstance();
    const calcDate = Form.useWatch(relativeDateFieldName, form);

    const fullDate = calcDate
      ? moment(calcDate).add(value, 'minutes').format('HH:mm DD.MM.YYYY')
      : '-';

    const duration = withDuration ? moment.duration(value, 'minutes') : null;
    const formatedDuration = duration
      ? `за ${formatPosInt(duration.asDays())} д. ${formatPosInt(
          duration.hours()
        )} ч. ${formatPosInt(duration.minutes())} мин`
      : null;

    return (
      <>
        <InputNumber
          addonAfter="мин"
          max={0}
          status={status}
          style={{ width: '50%', verticalAlign: 'middle' }}
          value={value}
          onChange={onChange}
        />

        {relativeDateFieldName && (
          <>
            <Divider type="vertical" />
            <span>{fullDate}</span>
          </>
        )}
        {formatedDuration && (
          <>
            <Divider type="vertical" />
            <span>{formatedDuration}</span>
          </>
        )}
      </>
    );
  }
);
